import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import sample from './sample';
import challenges from './challenges';
import apply from './apply';
import details from './details';

export default combineReducers({
  routerReducer,
  sample,
  challenges,
  apply,
  details
});



// WEBPACK FOOTER //
// ./src/reducers/index.js